/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_6_TitleInputs */

const en_gc_search_guides_gridcraft_excel_compatibility_sections_6_title = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_6_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diagnose a mismatch before changing more cells`)
};

const zh_gc_search_guides_gridcraft_excel_compatibility_sections_6_title = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_6_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`出现差异时，先定位再继续编辑`)
};

/**
* | output |
* | --- |
* | "Diagnose a mismatch before changing more cells" |
*
* @param {Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_6_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_excel_compatibility_sections_6_title = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_6_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_6_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_excel_compatibility_sections_6_title(inputs)
	return zh_gc_search_guides_gridcraft_excel_compatibility_sections_6_title(inputs)
});
export { gc_search_guides_gridcraft_excel_compatibility_sections_6_title as "gc.search_guides.gridcraft_excel_compatibility.sections.6.title" }